import { createSlice } from '@reduxjs/toolkit';

/**
 * RAT-1760: the operation log list (AC-6).
 *
 * Read-only by design - entries are written by the routes that change data, so
 * there are no create/update/delete actions here.
 */
const OperationLogSlice = createSlice({
  name: 'OperationLogSlice',
  initialState: {
    isLoading: false,
    operationLogData: null,
    isError: null,
  },
  reducers: {
    requestOperationLogList: (state) => {
      return { ...state, isLoading: true };
    },
    responseOperationLogList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        operationLogData: action?.payload?.data,
      };
    },
    failureOperationLogList: (state, action) => {
      return {
        ...state,
        isLoading: false,
        isError: action?.payload,
      };
    },
  },
});

export const {
  requestOperationLogList,
  responseOperationLogList,
  failureOperationLogList,
} = OperationLogSlice.actions;

export default OperationLogSlice.reducer;
